import {
  Button,
  FlexBox,
  ModalBody,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import useArticleUnpublish from 'articleEditor/hooks/useArticleUnpublish';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';
import { useNotification } from 'lib-knowledge-utils/hooks/useNotification';
import { useCallback } from 'react';

type ArticleUnPublishModalProps = {
  articleId: string;
  articleTitle: string;
};

export function ArticleUnPublishModal({
  articleId,
  articleTitle,
}: ArticleUnPublishModalProps): JSX.Element {
  const [unPublishFn, { loading }] = useArticleUnpublish({
    articleId,
  });
  const { hideModal } = useModal();
  const { successNotify, errorNotify } = useNotification();
  const unpublish = useCallback(() => {
    unPublishFn()
      .then(() => {
        successNotify({
          title: 'Success',
          text: `“${articleTitle}” has been unpublished`,
        });
        hideModal();
      })
      .catch(() => {
        errorNotify({
          title: 'Error',
          text: `“${articleTitle}” could not be unpublished. Please try again or contact support.`,
        });
      });
  }, [articleTitle, unPublishFn, successNotify, errorNotify, hideModal]);

  return (
    <ModalWrapper>
      <ModalHead title="Unpublish Article" onClose={hideModal}></ModalHead>
      <ModalBody>
        <Text.Paragraph>
          Are you sure you want to unpublish <strong>“{articleTitle}”</strong>?
        </Text.Paragraph>
        <FlexBox justifyContent="flex-end" gap="100">
          <Button disabled={loading} variant="tertiary" onClick={hideModal}>
            Cancel
          </Button>
          <Button disabled={loading} onClick={unpublish}>
            {loading ? 'Unpublishing...' : 'Unpublish'}
          </Button>
        </FlexBox>
      </ModalBody>
    </ModalWrapper>
  );
}
